import { getErrorsByType } from '../../control'
import { CsvDataImporterArgs } from '../../../modals/CsvModal/CsvModal'
import { generateElementID } from '../../../../utils/generateElementID'

interface ValidateDataFromCsvArgs extends Omit<CsvDataImporterArgs, 'setData'> {
    componentSchema: any
    columnsValidators: any
}

export const validateCsvDataAndAddElementId = (args: ValidateDataFromCsvArgs) => {

    const { dataFromCsv, columnsValidators, componentSchema, setError, setErrPosition } = args

    for (let i = 0, len = dataFromCsv.length; i < len; i++) {

        const rowData = dataFromCsv[i]

        for (let key in rowData) {
            if (rowData.hasOwnProperty(key)) {
                const cellData = rowData[key]
                const isCellValid = columnsValidators[key].isValidSync(cellData)

                if (!isCellValid) {
                    const columnSchema = componentSchema[key]
                    const err = getErrorsByType(
                        columnSchema.type,
                        cellData,
                        columnSchema
                    )
                    setError({
                        message:
                            err?.message! || 'field-validation-error',
                        values: err?.values,
                    })
                    setErrPosition({ column: key, row: i + 1 })
                    return
                }
            }
        }

        rowData.element_id = generateElementID()
    }
    return true
}
